import React from 'react';

import { useConstructorBackgroundImage } from '../../hooks/useConstructorBackgroundImage';
import OneNightStandBase from '../OneNightStand/OneNightStandBase';

const OneNightStandConstructorVariant: React.FC = () => {
  const backgroundImage = useConstructorBackgroundImage();

  return <OneNightStandBase backgroundImage={backgroundImage} />;
};

export default OneNightStandConstructorVariant;
